var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckedMarkSuccessSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1804,
    cx: 36,
    cy: 36,
    r: 36,
    fill: "#44D7B6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 18C26.5588 18 18.5 26.0588 18.5 36C18.5 45.9412 26.5588 54 36.5 54C46.4412 54 54.5 45.9412 54.5 36C54.5 26.0588 46.4412 18 36.5 18ZM36.5 21.4839C44.5225 21.4839 51.0161 27.9763 51.0161 36C51.0161 44.0225 44.5237 50.5161 36.5 50.5161C28.4775 50.5161 21.9839 44.0237 21.9839 36C21.9839 27.9775 28.4763 21.4839 36.5 21.4839ZM46.6761 30.9387L45.0404 29.2898C44.7017 28.9484 44.1502 28.9461 43.8087 29.2849L33.5493 39.4619L29.2096 35.0869C28.8708 34.7454 28.3194 34.7432 27.9779 35.0819L26.3289 36.7176C25.9874 37.0563 25.9852 37.6078 26.324 37.9494L32.9129 44.5917C33.2517 44.9332 33.8031 44.9354 34.1446 44.5966L46.6712 32.1705C47.0127 31.8317 47.0148 31.2802 46.6761 30.9387Z",
    fill: "#44D7B6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedMarkSuccessSvg);
export default __webpack_public_path__ + "static/media/checked_mark_success-svg.f9643585.svg";
export { ForwardRef as ReactComponent };